import React from 'react';
import {ScrollView, Text} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import {
  ASSOCIATE_DIRECTOR,
  COACH,
  DIRECTOR,
  EXECUTIVE_DIRECTOR,
  GLOBAL_DIRECTOR,
  INTEGRATED_EXECUTIVE_DIRECTOR,
  INTEGRATED_GLOBAL_DIRECTOR,
  INTEGRATED_NATIONAL_DIRECTOR,
  INTEGRATED_PRESIDENTIAL_DIRECTOR,
  INTEGRATED_REGIONAL_DIRECTOR,
  MANAGER,
  NATIONAL_DIRECTOR,
  PRESIDENTIAL_DIRECTOR,
  REGIONAL_DIRECTOR,
  SENIOR_COACH,
} from '/enum/rank.enum';

import RankIcon from '../RankIcon';

storiesOf('base', module).add('RankIcon', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Heading level={1}>Rank Icon</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>RankIcon</Code> component is used to render a icon for a
          user's rank.
        </Text>
        <Spacer size={16} />
        <Text>
          The user's rank is specified by passing the <Code>rank</Code> prop to
          the <Code>RankIcon</Code> component.
        </Text>
        <Spacer size={16} />
        <FlexView direction="horizontal" align="center">
          <RankIcon rank={COACH} />
          <Spacer direction="horizontal" size={6} />
          <Code>{'rank={COACH}'}</Code>
        </FlexView>
        <Spacer size={16} />
        <FlexView direction="horizontal" align="center">
          <RankIcon rank={SENIOR_COACH} />
          <Spacer direction="horizontal" size={6} />
          <Code>{'rank={SENIOR_COACH}'}</Code>
        </FlexView>
        <Spacer size={16} />
        <FlexView direction="horizontal" align="center">
          <RankIcon rank={MANAGER} />
          <Spacer direction="horizontal" size={6} />
          <Code>{'rank={MANAGER}'}</Code>
        </FlexView>
        <Spacer size={16} />
        <FlexView direction="horizontal" align="center">
          <RankIcon rank={ASSOCIATE_DIRECTOR} />
          <Spacer direction="horizontal" size={6} />
          <Code>{'rank={ASSOCIATE_DIRECTOR}'}</Code>
        </FlexView>
        <Spacer size={16} />
        <FlexView direction="horizontal" align="center">
          <RankIcon rank={DIRECTOR} />
          <Spacer direction="horizontal" size={6} />
          <Code>{'rank={DIRECTOR}'}</Code>
        </FlexView>
        <Spacer size={16} />
        <FlexView direction="horizontal" align="center">
          <RankIcon rank={EXECUTIVE_DIRECTOR} />
          <Spacer direction="horizontal" size={6} />
          <Code>{'rank={EXECUTIVE_DIRECTOR}'}</Code>
        </FlexView>
        <Spacer size={16} />
        <FlexView direction="horizontal" align="center">
          <RankIcon rank={INTEGRATED_EXECUTIVE_DIRECTOR} />
          <Spacer direction="horizontal" size={6} />
          <Code>{'rank={INTEGRATED_EXECUTIVE_DIRECTOR}'}</Code>
        </FlexView>
        <Spacer size={16} />
        <FlexView direction="horizontal" align="center">
          <RankIcon rank={REGIONAL_DIRECTOR} />
          <Spacer direction="horizontal" size={6} />
          <Code>{'rank={REGIONAL_DIRECTOR}'}</Code>
        </FlexView>
        <Spacer size={16} />
        <FlexView direction="horizontal" align="center">
          <RankIcon rank={INTEGRATED_REGIONAL_DIRECTOR} />
          <Spacer direction="horizontal" size={6} />
          <Code>{'rank={INTEGRATED_REGIONAL_DIRECTOR}'}</Code>
        </FlexView>
        <Spacer size={16} />
        <FlexView direction="horizontal" align="center">
          <RankIcon rank={NATIONAL_DIRECTOR} />
          <Spacer direction="horizontal" size={6} />
          <Code>{'rank={NATIONAL_DIRECTOR}'}</Code>
        </FlexView>
        <Spacer size={16} />
        <FlexView direction="horizontal" align="center">
          <RankIcon rank={INTEGRATED_NATIONAL_DIRECTOR} />
          <Spacer direction="horizontal" size={6} />
          <Code>{'rank={INTEGRATED_NATIONAL_DIRECTOR}'}</Code>
        </FlexView>
        <Spacer size={16} />
        <FlexView direction="horizontal" align="center">
          <RankIcon rank={GLOBAL_DIRECTOR} />
          <Spacer direction="horizontal" size={6} />
          <Code>{'rank={GLOBAL_DIRECTOR}'}</Code>
        </FlexView>
        <Spacer size={16} />
        <FlexView direction="horizontal" align="center">
          <RankIcon rank={INTEGRATED_GLOBAL_DIRECTOR} />
          <Spacer direction="horizontal" size={6} />
          <Code>{'rank={INTEGRATED_GLOBAL_DIRECTOR}'}</Code>
        </FlexView>
        <Spacer size={16} />
        <FlexView direction="horizontal" align="center">
          <RankIcon rank={PRESIDENTIAL_DIRECTOR} />
          <Spacer direction="horizontal" size={6} />
          <Code>{'rank={PRESIDENTIAL_DIRECTOR}'}</Code>
        </FlexView>
        <Spacer size={16} />
        <FlexView direction="horizontal" align="center">
          <RankIcon rank={INTEGRATED_PRESIDENTIAL_DIRECTOR} />
          <Spacer direction="horizontal" size={6} />
          <Code>{'rank={INTEGRATED_PRESIDENTIAL_DIRECTOR}'}</Code>
        </FlexView>
      </FlexView>
    </Spacing>
  </ScrollView>
));
